let _viggo = null

export async function loadViggo() {
  if (_viggo) {
    return _viggo
  } else {
    _viggo = await import('@fortawesome-internal-tools/viggo')
    return _viggo
  }
}
